<template>
  <section class="followEdit">
    <van-nav-bar title="随访记录" left-arrow @click-left="$router.go(-1)">
      <template #left></template>
      <template #right>
        <div></div>
      </template>
    </van-nav-bar>
    <div class="followBody">
      <forms :data="info" @getFormPicker="getFormPicker"></forms>
      <button class="save" @click="save" v-if="edit">保存</button>
    </div>
    <div class="picker">
      <van-datetime-picker
        v-model="currentDate"
        v-if="showTimePicker"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
      <van-picker
        v-model="showPicker"
        v-if="showPicker"
        show-toolbar
        :title="title"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </div>
  </section>
</template>
<script>
import forms from '../../../components/basics/form.vue';
export default {
  props: {},
  data () {
    return {
      info: [],
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      showTimePicker: false,
      columns: [],
      showPicker: false,
      returnData: '',
      edit: false,
      checkId: 0,
      templateId: 0,
      pickerArr: [],
      title: '',
      templateJson: '',
      addFollow: '',
      caseId: 0,
      ehrId: 0,
      expertArr: []
    };
  },
  created () {
    if (Number(this.$route.query.edit) === 1) {
      this.edit = true
    }
    this.checkId = Number(this.$route.query.checkId)
    this.templateId = Number(this.$route.query.templateId)
    this.addFollow = this.$route.query.type
    this.caseId = Number(this.$route.query.caseId)
    this.ehrId = Number(this.$route.query.ehrId)
    this.getFollowInfo()
  },
  methods: {
    // 获取随访信息
    getFollowInfo () {
      this.$axios.post('api/ehr/template/information', {
        version: this.$version,
        data: { checkId: this.checkId, templateId: this.templateId }
      }).then(res => {
        if (res.status) {
          this.templateId = res.data.templateId
          this.templateJson = JSON.stringify(res.data.list);
          if (!this.edit) {
            // 预览
            var treatFunction = false
            res.data.list.forEach((item, index) => {
              this.info.push(
                {
                  label: item.name,
                  value: item.value
                }
              )
              if (item.value === '手术治疗') {
                treatFunction = true
              }
            })
            if (!treatFunction) {
              for (let i = this.info.length - 1; i >= 0; i--) {
                if (this.info[i].label === '手术日期' || this.info[i].label === '手术性质' || this.info[i].label === '术后复发') {
                  this.info.splice(i, 1)
                }
              }
            }
          } else {
            // 编辑
            this.pickerArr = []
            res.data.list.forEach(item => {
              if (item.type === '0') {
                this.info.push(
                  {
                    label: item.name,
                    value: item.value,
                    edit: true,
                    id: item.id,
                    required: item.required
                  }
                )
              } else if (item.type === '1') {
                this.info.push(
                  {
                    label: item.name,
                    value: item.value,
                    field: true,
                    id: item.id,
                    required: item.required
                  }
                )
              } else if (item.type === '2') {
                this.pickerArr.push(
                  {
                    id: item.id,
                    selects: item.selects,
                    name: item.name,
                    required: item.required
                  }
                )

                if (item.name === '手术性质' || item.name === '术后复发') {
                  this.info.push(
                    {
                      label: item.name,
                      value: item.value,
                      picker: String(item.id),
                      id: item.id,
                      hidden: true,
                      required: item.required
                    }
                  )
                } else {
                  this.info.push(
                    {
                      label: item.name,
                      value: item.value,
                      picker: String(item.id),
                      id: item.id,
                      required: item.required
                    }
                  )
                }
              } else if (item.type === '3') { // 治疗方法
                this.pickerArr.push(
                  {
                    id: item.id,
                    selects: item.selects,
                    name: item.name,
                    required: item.required
                  }
                )
                this.info.push(
                  {
                    label: item.name,
                    value: item.value,
                    picker: String(item.id),
                    id: item.id,
                    required: item.required
                  }
                )
              } else if (item.type === '4') { // 时间
                if (item.name === '手术日期') {
                  this.info.push(
                    {
                      label: item.name,
                      value: item.value,
                      picker: 'followTime',
                      id: item.id,
                      hidden: true,
                      required: item.required
                    }
                  )
                } else {
                  this.info.push(
                    {
                      label: item.name,
                      value: item.value,
                      picker: 'followTime1',
                      id: item.id,
                      required: item.required
                    }
                  )
                }
              }
            })
          }
        }
      })
    },
    // 获取新建随访模板
    getEditForm (id) {
      this.$axios
        .post('case/check/create', {
          data: {
            caseId: this.caseId,
            ehrId: this.ehrId,
            organizationCode: this.$store.state.userInfo.organizationCode,
            organizationId: this.$store.state.userInfo.organizationId,
            templateId: id,
            userId: this.$store.state.userInfo.id
          },
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            this.checkId = res.data.checkId
            if (this.addFollow === 'add') {
              this.addFollow = ''
              this.save()
            }
          }
        });
    },
    // 点击联级选择器
    getFormPicker (e) {
      this.returnData = e;
      if (e === 'followTime' || e === 'followTime1') {
        this.showPicker = false
        this.showTimePicker = true
        this.title = ''
      } else {
        this.showTimePicker = false
        this.pickerArr.forEach(item => {
          if (String(item.id) === e) {
            this.columns = item.selects
            this.title = item.name
          }
        })
        this.showPicker = true;
      }
    },
    // 联级选择器确认
    onConfirm (value) {
      if (this.title === '治疗方法' && value === '手术治疗') {
        this.info.forEach(item => {
          if (item.label === '手术日期' || item.label === '手术性质' || item.label === '术后复发') {
            item.hidden = false
          }
        })
      } else if (this.title === '治疗方法' && value !== '手术治疗') {
        this.info.forEach(item => {
          if (item.label === '手术日期' || item.label === '手术性质' || item.label === '术后复发') {
            item.hidden = true
          }
        })
      }
      if (this.returnData === 'followTime' || this.returnData === 'followTime1') {
        var d = new Date(value)
        var month = Number(d.getMonth() + 1)

        if (month < 10) {
          month = '0' + month
        }
        var day = Number(d.getDate())
        if (day < 10) {
          day = '0' + day
        }
        var datetime = d.getFullYear() + '-' + month + '-' + day
      }
      this.info.forEach((item, index) => {
        if (item.label === '随访时间' && item.picker === this.returnData) {
          item.value = datetime
          this.showTimePicker = false
        } else if (item.label === '手术日期' && item.picker === this.returnData) {
          item.value = datetime
          this.showTimePicker = false
        } else if (this.returnData === item.picker) {
          item.value = value
          this.showPicker = false
        }
      })
    },
    // 联级选择器取消
    onCancel () {
      if (this.returnData === 'followTime' || this.returnData === 'followTime1') {
        this.showTimePicker = false;
      } else {
        this.showPicker = false;
      }
    },
    // 随访保存
    save () {
      var formJson = [];
      var require = true;
      var treatFunction = false
      this.info.forEach((e, index) => {
        if (e.required === 2 && (e.value === '' || e.value === null) && require) {
          require = false
          this.$toast(e.label + '为必填项')
        }
        formJson.push({
          id: e.id,
          value: e.value
        });
        if (e.label === '治疗方法' || e.value === '手术治疗') {
          treatFunction = true
        }
      })
      if (treatFunction) {
        this.info.forEach((e, index) => {
          if ((e.label === '手术日期' || e.label === '手术性质' || e.label === '术后复发') && e.value === null) {
            require = false
            this.$toast(e.label + '为必填项')
          }
        })
      }
      if (!treatFunction) {
        for (let i = formJson.length - 1; i >= 0; i--) {
          if (formJson[i].label === '手术日期' || formJson[i].label === '手术性质' || formJson[i].label === '术后复发') {
            formJson.splice(i, 1)
          }
        }
      }
      if (this.addFollow === 'add') {
        this.getEditForm(this.templateId)
        return
      }
      var Data = {
        caseId: this.caseId,
        ehrId: this.ehrId,
        checkId: this.checkId,
        json: JSON.stringify(formJson),
        organizationCode: this.$store.state.userInfo.organizationCode,
        organizationId: this.$store.state.userInfo.organizationId,
        templateJson: this.templateJson,
        userId: this.$store.state.userInfo.id
      };
      if (require) {
        this.$axios.post('case/check/save', {
          version: this.$version,
          data: Data
        }).then(res => {
          if (res.status) {
          // 返回上一页
            this.$router.push(
              {
                path: '/casedetail',
                query: {
                  caseid: this.caseId
                }
              }
            )
          }
        })
      }
    }
  },
  watch: {},
  computed: {},
  components: {
    forms
  }
};
</script>
<style lang="scss" scoped>
.followEdit {
  height: calc(100% + 56px);
  position: relative;
  background-color: $white;
  z-index: 1;
  .followBody {
    width: 100%;
    height: 100%;
    .save {
      height: 52px;
      width: 100%;
      text-align: center;
      background-image: linear-gradient(90deg, $blue5c94ff 21%, $blue77de5 83%);
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: $white;
      letter-spacing: 0.21px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .picker {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>
